module.exports = __webpack_public_path__ + "img/d-up-light.5511dfa3.png";